// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { FITS, DEPTH, SNAP, snapOverlap, fmt } from '../doc.js';
const S = {
  title: "带标志的咖啡杯",
  gLogo: "杯上的标志",
  gSize: "杯子尺寸",
  gColour: "颜色",
  gLid: "盖子与打印",
  loadingFont: (family, got, total) => (total > 0 ? `正在加载 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在加载 ${family} ${got.toFixed(1)} MB`),
  needFile: "选择标志的 SVG 文件——它只留在您的设备上，不会发送到任何地方",
  artKept: "标志只存在于当前标签页——刷新后需重新选择文件",
  keptOld: "（仍在使用先前的标志）",
  thumb: "已读取标志的预览",
  mode: "标志风格",
  modes: {
    flush: "平齐",
    raised: "凸起",
    engraved: "雕刻",
  },
  styleLabel: "杯型",
  styles: {
    classic: "经典杯型",
    thin: "真正薄壁",
  },
  modeNote: (style, mode) => {
      if (mode === 'raised') return `凸起 ${fmt(DEPTH[style].raised[1])} 毫米——多色和单色打印机都可用（单色时呈现为浮雕）`;
      if (mode === 'engraved') return `雕刻 ${fmt(DEPTH[style].engraved[0])} 毫米深，标志不单独成件——适合单色打印机`;
      const flush = '与杯面平齐——面向多色打印机（单色时看不到标志）';
      return style === 'thin' ? `${flush} 薄壁：标志厚 ${fmt(DEPTH.thin.flush[0])} 毫米；深色杯身上的浅色标志可能偏暗——要扎实的颜色请选凸起` : flush;
    },
  scale: "标志大小",
  pos: "上下移动",
  hideThin: "隐藏过薄、无法打印的部分",
  signedPercent: (v) => `${v > 0 ? '+' : ''}${Math.round(v * 100)}%`,
  size: "尺寸",
  presets: {
    mini: "迷你",
    s: "S",
    m: "M",
    l: "L",
  },
  d: "直径（毫米）",
  adjusted: (v, lo, hi) => `已设为 ${v} 毫米（可用范围 ${lo}–${hi} 毫米）`,
  looks: "配色",
  lookNames: {
    mono: "黑白",
    kraft: "牛皮纸",
    white: "白色",
  },
  parts: {
    body: "杯子",
    ring: "挂环",
    logo: "标志",
  },
  colour: {
    body: "杯身颜色",
    lid: "盖子颜色",
    ring: "挂环颜色",
    logo: "标志颜色",
  },
  lidOn: "加一个盖子",
  ringOn: "挂环",
  fit: "盖子松紧",
  fits: {
    tight: "非常紧",
    snug: "贴紧",
    normal: "略松",
    loose: "宽松",
  },
  fitNote: (style, fit, d) => {
      if (style !== 'thin') return `${fmt(FITS[fit])} 毫米边距——盖子靠摩擦扣住，没有卡扣`;
      if (fit === 'loose') return `盖子宽松、不卡扣——每侧 ${fmt(SNAP.loose.c)} 毫米边距`;
      return `盖子卡在杯沿下——卡扣搭接 ${snapOverlap(SNAP[fit], d).toFixed(2)} 毫米`;
    },
  partLabel: "已下载的文件",
  partNames: {
    set: "设定",
    cup: "杯子",
    lid: "盖子",
  },
  lift: "揭开盖子",
  outer: (d, h) => `ø ${d} × ${h} 毫米`,
  footprint: (w, d) => `打印占地 ${w} × ${d} 毫米`,
  capacity: (ml) => `容量 ${ml} 毫升`,
  problem: {
    "thin-text": "字母很细——有些笔画可能打印不出来；请用更大的杯子或减少字符",
    "thin-parts": "标志的细笔画连着厚实部分——切片软件可能把它们切掉",
    dropped: (p) => `已从标志中丢弃 ${p.n} 个过薄、无法打印的部分`,
    "all-thin": "标志对这个杯径来说太薄——无法下载",
    "art-too-complex": "标志太复杂——无法下载",
  },
  hairline: "限制：标志上连着厚实部分的极细笔画无法被检测，切片软件可能将其切掉——打印前请在切片软件里检查预览",
  dlstl: "STL",
  copied: "已复制",
  fatal: "无法加载计算器——请尝试刷新页面",
  buildTimeout: (src) => (src === 'svg' ? '生成 10 秒未完成，已重新开始——请换更简单的文件' : '生成 10 秒未完成，已重新开始——请减少字符或换字体'),
  aboutP: "设计带盖的迷你咖啡杯 — 杯身放名字或店标，自选尺寸、颜色和盖子松紧，免费下载 3MF/STL。这是装饰模型，不是饮用容器。",
};
export default S;
